import request, { uploadRequest } from './request'

// 议案列表查询
export function getProposalList (params) {
  return request({
    url: '/admin/proposal/list',
    method: 'get',
    params
  })
}

// 新增议案
export function addProposal (data) {
  return request({
    url: '/admin/proposal/add',
    method: 'post',
    data
  })
}

// 编辑议案
export function updateProposal (data) {
  return request({
    url: '/admin/proposal/update',
    method: 'put',
    data
  })
}

// 删除议案
export function deleteProposal (id) {
  return request({
    url: `/admin/proposal/delete/${id}`,
    method: 'delete'
  })
}

// 查看议案详情
export function getProposalDetail (id) {
  return request({
    url: `/admin/proposal/detail/${id}`,
    method: 'get'
  })
}

// 议案预览
export function previewProposal (id) {
  return request({
    url: `/admin/proposal/preview/${id}`,
    method: 'get'
  })
}

// 提交审核
export function submitProposal (id) {
  return request({
    url: `/admin/proposal/submit/${id}`,
    method: 'put'
  })
}

// 发布议案
export function publishProposal (id) {
  return request({
    url: `/admin/proposal/publish/${id}`,
    method: 'put'
  })
}

// 上传议案图片
export function uploadProposalImage (formData) {
  return uploadRequest({
    url: '/admin/file/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
